const TermsAndConditions = () => {
  return (
    <div className="bg-slate-50 text-black">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Terms &amp; Conditions
          </h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: January 2026</p>

          <div className="mt-8 space-y-10 leading-relaxed">
            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Company Identity &amp; Scope
              </p>
              <p className="mt-3 text-gray-700">
                These Terms &amp; Conditions apply to courier and cargo services provided by{" "}
                <strong>Sundarban Cargo Services UK Limited</strong> (“we”, “our”, “us”) in the United Kingdom and
                internationally. By placing an order, requesting a quote, or using our website/services, you agree to
                these terms.
              </p>
              <p className="mt-3 text-gray-700">
                We arrange shipment and delivery services and may use third‑party carriers and logistics partners to
                perform transportation, customs clearance, and delivery.
              </p>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Customer Responsibilities
              </p>
              <p className="mt-3 text-gray-700">You are responsible for ensuring that:</p>
              <ul className="mt-3 list-disc pl-6 text-gray-700 space-y-2">
                <li>All shipment information provided is accurate and complete.</li>
                <li>Items are correctly packed and protected unless a packing service is agreed with us.</li>
                <li>Contents comply with UK law and the destination country’s laws and regulations.</li>
                <li>
                  You provide any required documents for customs (including invoices, ID where required, and accurate
                  contents/value declarations).
                </li>
              </ul>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Prohibited Items
              </p>
              <p className="mt-3 text-gray-700">
                We do not accept prohibited or restricted items, including (but not limited to):
              </p>
              <ul className="mt-3 list-disc pl-6 text-gray-700 space-y-2">
                <li>Dangerous goods and hazardous materials.</li>
                <li>Illegal items or items prohibited by the destination country.</li>
                <li>Cash, explosives, firearms, ammunition, or counterfeit goods.</li>
              </ul>
              <p className="mt-3 text-gray-700">
                If a shipment contains prohibited or misdeclared items, we may refuse service and/or hand information to
                relevant authorities where required.
              </p>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Pricing &amp; Payment Terms
              </p>
              <ul className="mt-3 list-disc pl-6 text-gray-700 space-y-2">
                <li>Prices are subject to confirmation based on weight, dimensions, destination, and service level.</li>
                <li>Payment must be made in full before shipment processing unless otherwise agreed in writing.</li>
                <li>Online payments are processed securely via Stripe.</li>
              </ul>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Delays &amp; Third Parties (Customs)
              </p>
              <p className="mt-3 text-gray-700">
                Delivery times are estimates only. We are not responsible for delays caused by customs inspections,
                duties/taxes, regulatory checks, adverse weather, carrier network disruptions, or other third‑party
                factors outside our reasonable control.
              </p>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Liability Limitations
              </p>
              <ul className="mt-3 list-disc pl-6 text-gray-700 space-y-2">
                <li>Liability for loss or damage is limited in accordance with the carrier’s applicable terms.</li>
                <li>
                  We are not liable for indirect or consequential losses (including loss of profit, business, or
                  opportunity).
                </li>
                <li>
                  We are not responsible for loss/damage arising from inadequate packaging, misdeclaration, prohibited
                  items, or incorrect addresses provided by the customer.
                </li>
              </ul>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Right to Refuse Service
              </p>
              <p className="mt-3 text-gray-700">
                We reserve the right to refuse, suspend, or cancel service where shipment contents or documentation
                violate laws, carrier rules, safety requirements, or our policies, or where we reasonably suspect fraud
                or misdeclaration.
              </p>
            </section>

            <section>
              <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase">
                Governing Law
              </p>
              <p className="mt-3 text-gray-700">
                These Terms &amp; Conditions are governed by the laws of the <strong>United Kingdom</strong>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;


